import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useTheme, alpha } from "@mui/material/styles"; // Added alpha import

import {
  Box,
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Stack,
  IconButton,
  Divider,
  Button,
  useMediaQuery,
} from "@mui/material";

import {
  ChevronRight as ChevronRightIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
  Instagram as InstagramIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Place as PlaceIcon,
  Send as SendIcon,
} from "@mui/icons-material";

const Footer = () => {
  const { t } = useLanguage();
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        py: 6,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} sx={{ mb: 4 }}>
          <Grid item xs={12} md={5} lg={4}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
              <Box
                component="img"
                src="/assets/logo.png"
                alt={t("maintenanceReportSystem")}
                sx={{
                  height: 40,
                  mr: 2,
                  transition: "opacity 0.2s",
                  "&:hover": { opacity: 0.9 },
                }}
              />
              <Typography
                variant="h6"
                component="span"
                fontWeight="bold"
                letterSpacing="-0.3px"
              >
                {t("maintenanceReportSystem")}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ maxWidth: 320, lineHeight: 1.7 }}
            >
              {t("footerDescription") ||
                "Professional equipment management and maintenance tracking system for heavy machinery and excavators."}
            </Typography>

            <Box sx={{ mt: 3 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <PlaceIcon
                  fontSize="small"
                  sx={{ color: "text.secondary", mr: 1 }}
                />
                <Typography variant="body2" color="text.secondary">
                  {t("address") || "Herzbergstraße 19-21, 10365 Berlin, Germany"}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ mt: 1.5 }}
              >
                <EmailIcon
                  fontSize="small"
                  sx={{ color: "text.secondary", mr: 1 }}
                />
                <Typography variant="body2" color="text.secondary">
                  info@kanellos.de
                </Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ mt: 1.5 }}
              >
                <PhoneIcon
                  fontSize="small"
                  sx={{ color: "text.secondary", mr: 1 }}
                />
                <Typography variant="body2" color="text.secondary">
                  030 55741720
                </Typography>
              </Stack>
            </Box>
          </Grid>





          <Grid item xs={12} sm={4} md={3} lg={4}>
            <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
              <IconButton
                size="small"
                component="a"
                href="#"
                onClick={(e) => e.preventDefault()}
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  color: "primary.main",
                  "&:hover": {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    transform: "translateY(-3px)",
                  },
                  transition: "all 0.2s",
                }}
              >
                <FacebookIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                component="a"
                href="#"
                onClick={(e) => e.preventDefault()}
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  color: "primary.main",
                  "&:hover": {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    transform: "translateY(-3px)",
                  },
                  transition: "all 0.2s",
                }}
              >
                <TwitterIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                component="a"
                href="#"
                onClick={(e) => e.preventDefault()}
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  color: "primary.main",
                  "&:hover": {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    transform: "translateY(-3px)",
                  },
                  transition: "all 0.2s",
                }}
              >
                <LinkedInIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                component="a"
                href="#"
                onClick={(e) => e.preventDefault()}
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  color: "primary.main",
                  "&:hover": {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    transform: "translateY(-3px)",
                  },
                  transition: "all 0.2s",
                }}
              >
                <InstagramIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              &copy; {currentYear} {t("maintenanceReportSystem")}.{" "}
              {t("allRightsReserved")}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
